import TablaServidor from '../../components/tabla/TablaServidor';
import { useTituloCabecera } from '../../context/tituloCabeceraContext';
import { COLUMNAS_LOGS, TABLA_LOGS } from '../../components/logs/columnasLogs';

const Logs = () => {
  useTituloCabecera('Logs', 'Registro de actividad del sistema (últimos 20.000 registros)');
  return (
    <TablaServidor
      tablaKey={TABLA_LOGS}
      columnas={COLUMNAS_LOGS}
      ruta="listado-logs"
      archivo="logs"
      nombreEntidad="registros"
      placeholder="Buscar por usuario, acción, web o parámetros…"
      claveFila={(f) => `${f.empresaId}-${f.id}`}
      tituloTarjeta={(f) => `${f.action || ''} · ${f.userEmail || ''}`.trim()}
    />
  );
};

export default Logs;
